// extracted by mini-css-extract-plugin
export default {"connected":"Connected_connected__7ya2W","address":"Connected_address__6X6r8"};